import { Button, SceneWrapper } from '~/components';
import {
  Icon,
  Markdown,
  Typography,
  getTheme,
  pxToRem,
  styled,
} from '~/modules';

const smSpacing = getTheme('spacing.sm');
const mdSpacing = getTheme('spacing.md');
const lgSpacing = getTheme('spacing.lg');
const xlSpacing = getTheme('spacing.xl');

const textMain = getTheme('text.main');
const textLink = getTheme('text.link');

export const Wrapper = styled(SceneWrapper)`
  padding: ${lgSpacing}px;
`;

export const Title = styled(Typography).attrs({
  variant: 'max',
})`
  font-weight: 600;
  margin-bottom: ${smSpacing}px;
`;

export const MarkdownRenderer = styled(Markdown)``;

export const ButtonComponent = styled(Button)`
  margin: auto;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

export const Subtitle = styled(Typography).attrs({
  variant: 'lg',
})`
  font-weight: 400;
  opacity: 0.7;
  line-height: 1.5;
`;

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(64),
})`
  color: ${textMain};
  opacity: 0.5;
  margin-bottom: ${xlSpacing}px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${mdSpacing}px;
  margin-top: ${mdSpacing}px;
`;

export const StyledLink = styled.a`
  text-decoration: underline;
  font-weight: 600;
  font-size: ${pxToRem(16)};
  line-height: 1.5;
  color: ${textLink};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${mdSpacing}px;
`;
